"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const FontIcon_1 = __importDefault(require("../icon/FontIcon"));
const tooltip_1 = require("../tooltip");
const clsx_1 = require("clsx");
const interfaces_1 = require("./interfaces");
const LabelTooltipDecorator = ({ id, htmlFor, label, placement, tooltip, tooltipCloseLabel, showRequired, }) => {
    const [showTooltip, setShowTooltip] = (0, react_1.useState)(false);
    const classes = (0, clsx_1.clsx)('tk-label', {
        'tk-label--required': showRequired,
    });
    return label || tooltip ? ((0, jsx_runtime_1.jsxs)("div", { className: "tk-input-group__header", children: [label ? ((0, jsx_runtime_1.jsx)("label", { className: classes, htmlFor: htmlFor, children: label })) : null, tooltip ? ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(tooltip_1.Tooltip, { id: id, description: tooltip, closeLabel: tooltipCloseLabel, onHintClose: () => setShowTooltip(false), visible: showTooltip, placement: placement || 'top', children: (0, jsx_runtime_1.jsx)(FontIcon_1.default, { className: "tk-input-group__hint", iconName: "info-round", onClick: () => setShowTooltip(!showTooltip), onKeyDown: (event) => (event.key === 'Enter') && setShowTooltip(!showTooltip), tabIndex: 0 }) }) })) : null] })) : null;
};
LabelTooltipDecorator.propTypes = Object.assign({}, interfaces_1.LabelTooltipDecoratorPropTypes);
exports.default = LabelTooltipDecorator;
